/* eslint-disable no-underscore-dangle */
import { ChartConfiguration } from 'chart.js';

interface Chart {
  getElementAtEvent: (
    e: MouseEvent,
  ) => { _datasetIndex: number; _index: number }[];
}

export type DataSet = Chart.ChartDataSets & {
  customMetadatas?: any;
};

export function getLineChartConfig(args: {
  datasets: Array<DataSet>;
  labels: Array<string>;
  onChartClick: (event: MouseEvent, data: DataSet, label: string) => void;
}): ChartConfiguration {
  return {
    type: 'line',
    data: {
      labels: args.labels,
      datasets: args.datasets,
    },
    options: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              suggestedMax: 6,
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
      },
      tooltips: {
        displayColors: false,
        filter: (item, data) => {
          if (
            data.datasets &&
            item.datasetIndex &&
            item.index &&
            data.labels &&
            // if this tooltip item comes from a dataset with a border dash
            data.datasets[item.datasetIndex].borderDash &&
            // and it is not the last index (the last element on the chart)
            item.index < data.labels.length - 1
          ) {
            // do not display it
            return false;
          }
          // else, display it
          return true;
        },
      },
      legend: {
        display: false,
      },
      onClick: function onCanvasClick(event: MouseEvent) {
        const elementArray = (this as Chart).getElementAtEvent(event);
        if (elementArray.length) {
          const element = elementArray[0];
          args.onChartClick(
            event,
            args.datasets[element._datasetIndex],
            args.labels[element._index],
          );
        }
      },
      onHover: (event, elements) => {
        if (document.body) {
          if (elements.length) {
            document.body.style.cursor = 'pointer';
          } else {
            document.body.style.cursor = 'default';
          }
        }
      },
    },
  };
}

/* eslint-enable no-underscore-dangle */
